import axiosInstance from "../../interceptor/_axiosInstance";
import {
    PRODUCT_LIST,
    CREATE_PRODUCT,
    UPDATE_PRODUCT
} from "../../routes/routeConstants/apiRoutes";
import { deserialize } from "serializr";
import Notification from "../../shared/components/Notification";
import { NotificationTypes } from "../../enums/notificationTypes";
import { PaginationModel } from "../../models/PaginationModel/pagination.model";
import {
    Products,
} from "../../models/ProductModel/products.model";

export default class ProductService {

    static getProductList(
        queryParams: object,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .get(PRODUCT_LIST, { params: queryParams })
            .then((response) => {
                const productList = response.data["products"] !== null
                    ? deserialize(
                        Products,
                        response.data["products"]
                    )
                    : [];
                const pageMeta = response.data["meta"] !== null ? deserialize(PaginationModel, response.data["meta"]) : [];
                console.log(productList);


                onSuccess(productList, pageMeta);
            })
            .catch((error) => {
                Notification({
                    message: "Failed",
                    description: "Unable to fetch the product list",
                    type: NotificationTypes.ERROR,
                });
                onError(error);
            })
            .finally(onFinal);
    }

    static createProduct(
        data: any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .post(CREATE_PRODUCT, data)
            .then((response) => {
                if (response?.data?.isSucess)
                    onSuccess();
                else
                    throw response?.data?.errorMessage
            })
            .catch((error) => {
                Notification({
                    message: "Failed",
                    description: "Unable to create the product",
                    type: NotificationTypes.ERROR,
                });
                onError(error);
            })
            .finally(onFinal);
    }

    static updateProduct(
        data: any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .post(UPDATE_PRODUCT, data)
            .then((response) => {
                if (response?.data?.isSucess)
                    onSuccess();
                else
                    throw response?.data?.errorMessage

            })
            .catch((error) => {
                Notification({
                    message: "Failed",
                    description: "Unable to update the product",
                    type: NotificationTypes.ERROR,
                });
                onError(error);
            })
            .finally(onFinal);
    }


    static deleteProduct(
        data: any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .post(UPDATE_PRODUCT, data)
            .then((response) => {
                if (response?.data?.isSucess) {
                    Notification({
                        message: "Deleted",
                        description: "Product deleted successfully",
                        type: NotificationTypes.SUCCESS,
                    });
                    onSuccess();
                }

                else
                    throw response?.data?.errorMessage

            })
            .catch((error) => {
                Notification({
                    message: "Failed",
                    description: "Unable to delete the product",
                    type: NotificationTypes.ERROR,
                });
                onError(error);
            })
            .finally(onFinal);
    }

}
